<template>
  <div class="layout-tavolo-desktop">
    <v-main>
      <v-row no-gutters class="desktop-main-row">
        <!-- svincolati -->
        <v-col :cols="svincolatiCols">
          <div class="asta-svincolati-desktop">
            <asta-svincolati showTitle></asta-svincolati>
          </div>
        </v-col>
        <v-col :cols="centralCols" class="desktop-central">
          <!-- tavolo  -->
          <div class="asta-tavolo-desktop">
            <asta-tavolo></asta-tavolo>
          </div>
          <!-- chat -->
          <div class="asta-chat-messages-desktop">
            <asta-chat-messages></asta-chat-messages>
          </div>
          <div class="asta-chat-input-desktop">
            <asta-chat-input></asta-chat-input>
          </div>

        </v-col>
        <!-- rose -->
        <v-col cols="3">
          <div class="asta-rose-desktop">
            <asta-plan showTitle></asta-plan>
          </div>
        </v-col>
      </v-row>
    </v-main>
  </div>
</template>

<script>
import AstaTavolo from "../AstaTavolo.vue";
import AstaSvincolati from "../AstaSvincolati";
import AstaChatMessages from "../AstaChatMessages";
import AstaChatInput from "../AstaChatInput";
import AstaPlan from "../AstaPlan";
import mixins from "../../js/mixins";
import Constants from "../../js/constants";

export default {
  name: "layout-tavolo-desktop",
  mixins: [mixins],
  components: {
    AstaTavolo,
    AstaSvincolati,
    AstaChatMessages,
    AstaChatInput,
    AstaPlan,
  },
  data() {
    return {
      // value: Constants.ASTA_TABS.MAIN,
      // Config: Config
    };
  },

  computed: {
    isTabletBig() {
      return (
        this.$vuetify.breakpoint.width >=
        Constants.LAYOUT_BREAKPOINT.TABLET_BIG_MIN
      );
    },
    svincolatiCols() {
      return this.isTabletBig ? 3 : 4;
    },
    centralCols() {
      return this.isTabletBig ? 6 : 5;
    },
  },

  methods: {
    // selectTab: function (idx) {
    //   this.$store.dispatch("selectTab", idx);
    // },
  },
  mounted() {
    console.log("--> LayoutTavoloDesktop ready.");
  },
  destroyed() {
    console.log("<-- LayoutTavoloDesktop destroyed.");
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.desktop-main-row {
  // v-main__wrap is positioned and already excludes the app bar and footer.
  // Keep column content from increasing the height that anchors the chat input.
  position: absolute;
  inset: 0;
  min-height: 0;
}

.asta-rose-desktop {
  height: 100%;
  min-height: 0;
  overflow: hidden;
}

.asta-rose-desktop::v-deep .plan > :not(.plan-content),
.asta-rose-desktop::v-deep .plan-content > :not(.recycle-scroller) {
  flex: 0 0 auto;
}

.asta-rose-desktop::v-deep .plan-content {
  flex: 1 1 0;
  min-height: 0;
  overflow: hidden;
}

.asta-rose-desktop::v-deep .plan-content > .recycle-scroller {
  // Flex assigns the space left by the header; the full list scrolls within it.
  height: 0 !important;
  flex: 1 1 0;
  min-height: 0;
  overflow-y: auto;
}

.desktop-central {
  position: relative;
  // box-shadow: 0px 0px 22px 10px rgba(0, 0, 0, 0.2);
  .asta-tavolo-desktop {
    position: absolute;
    right: 0;
    top: 0px;
    left: 0;
    // bottom: 70%;
  }
  .asta-chat-messages-desktop {
    position: absolute;
    top: 30%; // serve per evitare che l'user tenti di scrollare sui messaggi che nn scrollerebbero
    bottom: 0;
    left: 0;
    right: 0;
    .chat {
      padding-bottom: 65px;
    }
  }
  .asta-chat-input-desktop {
    position: absolute;
    bottom: 10px;
    left: 0;
    right: 0;
  }
}

.v-main {
  height: 100vh;
  // background-image: url(/static/img/bg-seamless.png);
  // background-repeat: repeat;
  // background-color: white;
  background-color: var(--dark_main_bk);
  // background-image: linear-gradient(
  //   0deg,
  //   var(--v-navy-darken2),
  //   var(--v-navy-darken1) 300px
  // );
}
</style>
